import axios from "axios";
// import UserService from "../services/UserService";

const defaultUserLoginData = {
	user: null,
	token: null
};

export default function userReducer(state = defaultUserLoginData, action = {}) {
	switch (action.type) {
	case "USER_LOGGED_IN": {
		if (action.loginData && action.loginData.token) {
			axios.defaults.headers.common.Authorization = `Bearer ${action.loginData.token}`;
			return action.loginData;
		}
		return defaultUserLoginData;
	}
	case "USER_UPDATED": {
		const updatedUser = { ...state, user: { ...action.userData } };
		localStorage.setItem("loggedInUserData", JSON.stringify(updatedUser));
		return updatedUser;
	}
	case "USER_UPDATED_JWT": {
		const userData = { ...state, token: action.newToken };
		axios.defaults.headers.common.Authorization = `Bearer ${action.newToken}`;
		localStorage.setItem("loggedInUserData", JSON.stringify(userData));
		return userData;
	}
	default:
		return state;
	}
} 


// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js